import { create } from "zustand";

interface FormState {
  // Étape courante, pour les modes wizard et typeform
  currentStep: number;
  setCurrentStep: (step: number) => void;

  // Instant de départ, pour mesurer la durée
  startTime: number | null;
  setStartTime: (time: number) => void;

  // État de soumission du formulaire
  isSubmitting: boolean;
  setIsSubmitting: (submitting: boolean) => void;

  // Réinitialisation de l'état
  reset: () => void;
}

export const useFormStore = create<FormState>((set) => ({
  currentStep: 0,
  setCurrentStep: (step) => set({ currentStep: step }),

  startTime: null,
  setStartTime: (time) => set({ startTime: time }),

  isSubmitting: false,
  setIsSubmitting: (submitting) => set({ isSubmitting: submitting }),

  reset: () =>
    set({
      currentStep: 0,
      startTime: null,
      isSubmitting: false,
    }),
}));
